import {
  CreateProcessingTypeInputItemInput,
  CreateProcessingTypeOutputItemInput,
  UpdateProcessingTypeInputItemInput,
  UpdateProcessingTypeOutputItemInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createProcessingTypeAtom = createMutationAtomFactory(
  'production.createProcessingType',
  (params: {
    name: string;
    code: string;
    description?: string;
    isActive: boolean;
    inputItems?: CreateProcessingTypeInputItemInput[];
    outputItems?: CreateProcessingTypeOutputItemInput[];
  }) => ({
    productionProcessingTypeCreate: {
      __args: {
        input: {
          name: params.name,
          code: params.code,
          description: params.description,
          isActive: params.isActive,
          inputItems: params.inputItems,
          outputItems: params.outputItems,
        },
      },
      id: true,
      name: true,
      code: true,
      description: true,
      isActive: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
      inputItems: {
        id: true,
        itemId: true,
        isPrimary: true,
        sortOrder: true,
        notes: true,
      },
      outputItems: {
        id: true,
        itemId: true,
        outputUnit: true,
        yieldPercentage: true,
        isPrimary: true,
        isNoCost: true,
        costAllocationPercentage: true,
        sortOrder: true,
        notes: true,
      },
    },
  }),
);

export const updateProcessingTypeAtom = createMutationAtomFactory(
  'production.updateProcessingType',
  (params: {
    id: string;
    name?: string;
    code?: string;
    description?: string;
    isActive?: boolean;
    inputItems?: UpdateProcessingTypeInputItemInput[];
    outputItems?: UpdateProcessingTypeOutputItemInput[];
  }) => ({
    productionProcessingTypeUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          code: params.code,
          description: params.description,
          isActive: params.isActive,
          inputItems: params.inputItems,
          outputItems: params.outputItems,
        },
      },
      id: true,
      name: true,
      code: true,
      description: true,
      isActive: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
      inputItems: {
        id: true,
        itemId: true,
        isPrimary: true,
        sortOrder: true,
        notes: true,
      },
      outputItems: {
        id: true,
        itemId: true,
        outputUnit: true,
        yieldPercentage: true,
        isPrimary: true,
        isNoCost: true,
        costAllocationPercentage: true,
        sortOrder: true,
        notes: true,
      },
    },
  }),
);
